export default {"src":"/_next/static/media/WhoWeAre_010A.fac0c1f6.JPG","height":690,"width":1920};